import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button, space, device, color } from '@ticketswap/solar'
import PropTypes from '~/lib/propTypes'
import { track } from '~/utils/analytics'
import { PARTNER_DASHBOARD_CLICKED, SELL_STARTED } from '~/lib/tracking-events'
import Link from 'next/link'
import useLoggedInUser from '~/hooks/useLoggedInUser'
import { RouteMap } from '~/lib/routeMap'

const StyledButton = styled(Button)`
  align-self: flex-end;
  position: relative;
  margin-block: 0;
  margin-inline: auto;
  display: inline-flex;
  clear: both;
  ${({ type }) =>
    type !== 'default' &&
    css`
      background-color: rgb(0, 83, 111);
      background-image: none;

      &:hover {
        background-color: rgb(0, 102, 137);
      }
    `}

  ${({ type }) =>
    type === 'transformed' &&
    css`
      transform: translateY(40%);

      @media ${device.tablet} {
        padding-block: 16px;
        padding-inline: 90px;
      }
    `}

   ${({ type }) =>
    type === 'bordered' &&
    css`
      @media ${device.tablet} {
        padding-block: 16px;
        padding-inline: 90px;
      }

      &:before {
        content: '';
        position: absolute;
        width: calc(100% + ${space[16]});
        height: calc(100% + ${space[16]});
        inset-block-start: -${space[8]};
        inset-inline-start: -${space[8]};
        border: ${space[8]} solid ${color.stroke};
        pointer-events: none;
      }
    `}

     ${({ type }) =>
    type === undefined &&
    css`
      @media ${device.tablet} {
        padding-block: 16px;
        padding-inline: 90px;
      }
    `}
`

const BecomePartnerButton = ({ t, type, variant }) => {
  const { loggedInUser } = useLoggedInUser()
  const { isPartner, isTicketProvider } = loggedInUser || {}

  return (
    <>
      {isTicketProvider && (
        <Link prefetch={false} href={RouteMap['TICKET_PROVIDER_SELECT']} passHref>
          <StyledButton variant={variant} type={type} as="a">
            {t('common:menubar.partnersDashboard')}
          </StyledButton>
        </Link>
      )}
      {isPartner && !isTicketProvider && (
        <Link prefetch={false} href={RouteMap['PARTNER_DASHBOARD']} passHref>
          <StyledButton
            as="a"
            type={type}
            onClick={async () => {
              await track(PARTNER_DASHBOARD_CLICKED)
            }}
            variant={variant}
          >
            {t('common:menubar.partnersDashboard')}
          </StyledButton>
        </Link>
      )}
      {!isPartner && !isTicketProvider && (
        <Link prefetch={false} href={RouteMap['SELL']} passHref>
          <Button
            as="a"
            variant="success"
            size="medium"
            onClick={() => {
              track(SELL_STARTED, {
                source: 'menu header',
              })
            }}
          >
            {t('common:menubar.sellTickets')}
          </Button>
        </Link>
      )}
    </>
  )
}

BecomePartnerButton.propTypes = {
  t: PropTypes.func.isRequired,
  width: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
}

export default BecomePartnerButton
